/* eslint-disable no-undef */

import React from 'react'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import GoogleLogin from 'react-google-login'
import queryString from 'query-string'

import {
    Form,
    Input,
    Button,
    Row,
    Col,
    message,
    Tooltip,
    Icon,
    Menu,
    SubMenu,
    Divider,
    Anchor,
    Checkbox
} from 'antd'

import {
    refresh_profile,
    login,
    LOGIN_SUCCESS,
    register,
} from '../../../actions/auth'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import { receiveData } from '../../../api/http'

import wasabiDarkLogo from '../../../assets/logo/cloudflyer-logo-header.png';

import './styles.scss'

class WebRegister extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            busy: false,
            referrer_id: null,
            invite_token: null,
            token: null,
            confirmTerms: false,
            confirmPassword: false
        }
    }

    componentDidMount() {
        const { referrer_id, invite_token } = queryString.parse(
            this.props.location.search
        )
        
        var token = this.props.location.search.replace('?token=', '');
        
        var encoded = encodeURIComponent(token);



        if(token){

            this.setState({
                token: token
            })
            CloudFlyerAPI.new_user_account.signupInfo(encoded)
            .then(({ data }) => {

                const {email, firstname, lastname} = data

                this.props.form.setFieldsValue({
                    email ,
                    first_name: firstname,
                    last_name: lastname,
                })

            })
            .catch(function (err) {
                console.log(err);
            })
    
        }


        if (invite_token) {
            try {
                const decodedStr = atob(invite_token)
                const user = decodedStr.split('//')
                // format: email//firstname//lastname//roleid//orgid
                if (user.length === 5) {
                    const [email, first_name, last_name] = user
                    this.props.form.setFieldsValue({
                        email,
                        first_name,
                        last_name,
                    })
                    this.setState({
                        invite_token,
                    })
                }
            } catch (e) {
                console.log(
                    'base64 decoding for invite_token failed with error \n',
                    e
                )
            }
        }
        this.setState({
            loading: false,
            referrer_id: referrer_id ? referrer_id : undefined,
        })
    }


    handleSubmit(e) {
        const { history } = this.props        
        e.preventDefault()

        const {
            email,
            password,
            last_name,
            first_name,
            confirmPassword
        } = this.props.form.getFieldsValue()

        if (email === undefined || password === undefined) {
            this.setState({ busy: false })
            message.error('Incorrect user or password!')
        } else if(password !== confirmPassword) {
            message.error('Password and confirm password does not match!')
        } else {
            const { invite_token, referrer_id, token } = this.state
            let user = {
                password,
                lastname: last_name,
                firstname: first_name,
                token
            }

            CloudFlyerAPI.new_user_account.signup(user)
              .then(function (response) {
                message.success('Signup done successfully!')
                history.push('/login')
              })
              .catch(function (err) {

              })
    
        }
    }

    componentWillReceiveProps(props) {
        if (props.user) {
            if (this.state.invite_token)
                return this.props.history.replace('/login')
            if (props.success) this.props.history.replace('/postSignup')
        }
    }


    handleCheckConfirm = e => {
        const newState = { ...this.state }
        newState['confirmTerms'] = e.target.checked
        this.setState(newState)
    }

    toLogin() {
        let path =
            this.state.referrer_id !== undefined
                ? '/?referrer_id=' + this.state.referrer_id
                : ''
        this.props.history.replace('/login' + path)
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { referrer_id, invite_token } = this.state

        let google_client_id = window.GOOGLE_CLIENT_ID

        return (
            <div className="signup-container">
                <div className="signup-top-header">
                    <div className="logo">
                        <a href="/" target="_blank">
                            <img alt="wasabi logo" src={wasabiDarkLogo} />
                        </a>
                    </div>
                    <div className="link">
                        <a onClick={this.toLogin.bind(this)}>Log in</a>
                    </div>
                </div>
                <div className="signup-page">
                    <div className="box">
                        <div className="wasabiLogo">
                            <img alt="wasabi Logo" src={wasabiDarkLogo} />
                        </div>

                        <div className="right-panel">
                            <Form
                                className="signup-form"
                                layout="horizontal"
                                onSubmit={this.handleSubmit.bind(this)}>
                                <Form.Item>
                                    {getFieldDecorator('email')(
                                        <Input
                                            className="signup-input"
                                            placeholder="Work Email"
                                            readOnly = {true}
                                            disabled={!!invite_token}
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    <div className="full-name">
                                        {getFieldDecorator('first_name')(
                                            <Input
                                                className="first-name signup-input"
                                                placeholder="First Name"

                                            />
                                        )}

                                        {getFieldDecorator('last_name')(
                                            <Input
                                                className="last-name signup-input"
                                                placeholder="Last Name"
                                            />
                                        )}
                                    </div>
                                </Form.Item>
                                <Tooltip
                                    placement="rightTop"
                                    title="Password requirements: at least 8 characters, a lowercase letter, an uppercase letter, a number.">
                                    <a
                                        href=""
                                        onClick={e => e.preventDefault()}>
                                        <Form.Item>
                                            {getFieldDecorator('password')(
                                                <Input
                                                    type="password"
                                                    className="signup-input"
                                                    placeholder="Password"
                                                />
                                            )}
                                        </Form.Item>
                                    </a>
                                </Tooltip>
                                <Form.Item>
                                    {getFieldDecorator('confirmPassword')(
                                        <Input
                                            type="password"
                                            className="signup-input"
                                            placeholder="Confirm Password"
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    <div className="terms">
                                        <Checkbox
                                            onChange={this.handleCheckConfirm}
                                            checked={this.state.confirmTerms}>
                                            I accept Cloudflyer 
                                            <a target="_blank" href="https://www.cloudflyer.io/">Terms & Conditions</a>
                                        </Checkbox>
                                    </div>
                                </Form.Item>
                                
                                <Button
                                    className="signup-btn"
                                    type="primary"
                                    disabled={!this.state.confirmTerms}
                                    size="large"
                                    loading={this.state.busy}
                                    htmlType="submit"
                                    block>
                                    Sign Up
                                </Button>


                                {/* <p className="signup-msg">
                                    By signing up, you agree to CloudFlyer's{' '}
                                    <a
                                        target="_blank"
                                        href="https://www.CloudFlyer.com/terms-privacy-policy/">
                                        Terms of Service
                                    </a>
                                    .
                                </p> */}
                                <p className="signup-msg">
                                    Already have an account?{' '}
                                    <a
                                        className="toplinks"
                                        onClick={this.toLogin.bind(this)}>
                                        Log in
                                    </a>
                                    .
                                </p>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

WebRegister = Form.create()(WebRegister)

function mapStateToProps(state) {
    const { auth } = state
    if (auth) {
        return {
            user: auth.user,
            busy: auth.busy,
            success: auth.success,
            error: auth.error,
        }
    }
    return { user: null, busy: null, error: null }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            register,
            dispatch,
        },
        dispatch
    )

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(WebRegister)
)
